// Base API URL - dev
export const API_BASE_URL = process.env.API_URL
    ? process.env.API_URL
    : 'https://apiv3.litterati.org';

// Base API URL

export const BASE_URL_V6 = `${API_BASE_URL}/v6`;

export const BASE_PARTNER_URL_V6 = `${BASE_URL_V6}/partner`;

export const BASE_USER_URL_V6 = `${BASE_URL_V6}/user`;

// API Endpoints

export const GET_SPECIFIC_LITTER = `${BASE_PARTNER_URL_V6}/litter`;

export const AUTH_LOGIN_URL = `${BASE_URL_V6}/auth/login`;

export const AUTH_FB_LOGIN_URL = `${BASE_URL_V6}/auth/facebook-login`;

export const AUTH_SIGNUP_URL = `${API_BASE_URL}/auth/signup?isPartner=true`;

export const AUTH_FORGOTPASSWORD_URL = `${API_BASE_URL}/v6/auth/forgot-password`;

export const AUTH_RESETPASSWORD_URL = `${API_BASE_URL}/v6/auth/change-password`;

export const PRICING_URL = `${BASE_URL_V6}/pricing`;

export const PARTNER_LIST_URL = `${BASE_PARTNER_URL_V6}/list`;

export const PARTNER_TOKEN_URL = `${BASE_PARTNER_URL_V6}/token/`;

export const REFRESH_USER_TOKEN_URL = `${BASE_USER_URL_V6}/refresh-token`;

export const TOP_CONTRIBUTORS_URL = `${BASE_PARTNER_URL_V6}/top-contributors`;

export const TOP_TAGS_URL = `${BASE_PARTNER_URL_V6}/top-tags`;

export const ACTIVITY_CALENDAR_URL = `${BASE_PARTNER_URL_V6}/monthly-activity`;

export const ALL_LITTERS_URL = `${BASE_PARTNER_URL_V6}/litter-location`;

export const GET_REPORT_CSV = `${BASE_PARTNER_URL_V6}/report/csv`;

export const GET_MS4_REPORT = `${BASE_PARTNER_URL_V6}/report/ms4`;

export const TAGS_URL = `${BASE_PARTNER_URL_V6}/tags`;

export const ML_TAGS_URL = `${BASE_PARTNER_URL_V6}/distilled-top-tags`;

export const USERS_URL = `${BASE_PARTNER_URL_V6}/users`;

export const REPORTS_URL = `${BASE_PARTNER_URL_V6}/report/graph`;

export const PIECES_COLLECTED_URL = `${BASE_PARTNER_URL_V6}/litter-count`;

export const PARTNER_CHALLENGE_NAMES_URL = `${BASE_PARTNER_URL_V6}/challenge-names`;

export const PARTNER_CHALLENGES_URL = `${BASE_PARTNER_URL_V6}/challenges`;

export const PARTNER_CHALLENGE_URL = `${BASE_PARTNER_URL_V6}/challenge`;

export const PARTICIPATED_CHALLENGES_URL = `${BASE_URL_V6}/challenge/participated`;

export const PARTNER_CAMPAIGNS_URL = `${BASE_URL_V6}/campaign`;

export const GET_CAMPAIGN_CHALLENGES_URL = (campaignId) =>
    `${BASE_URL_V6}/campaign/${campaignId}/challenges`;

export const SEGMENT_TAGS_URL = `${BASE_PARTNER_URL_V6}/segment`;

export const UPDATE_SEGMENT_URL = (segmentId) =>
    `${BASE_URL_V6}/segment/${segmentId}`;

export const USER_SEGMENTS_URL = `${BASE_PARTNER_URL_V6}/user`;

export const ROLE_UPDATE_TO_PAID_CONTRIBUTOR_URL = `${BASE_URL_V6}/user/upgrade/paid-contributor`;

export const GET_PARTNER_CONNECTED_CHALLENGES_URL = (challengeId) =>
    `${BASE_PARTNER_URL_V6}/challenge/${challengeId}/connected-challenges`;

export const GET_CHALLENGE_CODES_URL = (challengeId) =>
    `${BASE_PARTNER_URL_V6}/challenge/${challengeId}/codes`;

export const CHALLENGE_NOTIFICATION_URL = `${BASE_PARTNER_URL_V6}/challenge/notification`;

export const NEW_CHALLENGE_CODE_URL = `${BASE_URL_V6}/challenge/validate-assign-code`;
export const UPDATE_CHALLENGE_CODE_URL = (id) =>
    `${BASE_URL_V6}/challenge/${id}/code`;

export const CHALLENGE_URL = `${BASE_URL_V6}/challenge`;

export const ANALYSIS_CHALLENGES_URL = `${BASE_URL_V6}/analysis/challenges`;

export const ANALYSIS_RESEARCHERS_URL = `${BASE_URL_V6}/analysis/researchers`;

export const ANALYSIS_SEGMENTS_URL = `${BASE_URL_V6}/analysis/segments`;

export const ANALYSIS_SUMMARY_TOP_TAGS_URL = `${BASE_URL_V6}/analysis/top-tags`;

export const ANALYSIS_SEGMENT_TAGS_URL = `${BASE_URL_V6}/analysis/tags`;

export const ANALYSIS_HEATMAP_LITTERS_URL = `${BASE_URL_V6}/analysis/heat-map-litters`;

export const ANALYSIS_SEGMENT_INDEX_URL = `${BASE_PARTNER_URL_V6}/get-segment-index`;

export const PARTNER_COUNTRIES_URL = `${BASE_PARTNER_URL_V6}/countries`;

// URL for the payment microservices
export const PAYMENT_SERVICE_BASE_URL = process.env.PAYMENT_SERVICE_BASE_URL
    ? process.env.PAYMENT_SERVICE_BASE_URL
    : 'https://payment.dev.litterati.org/';

export const CHARGE_CARD_URL = `${PAYMENT_SERVICE_BASE_URL}/charge`;

export const RECURRING_CHARGE_URL = `${PAYMENT_SERVICE_BASE_URL}recurring-charge`;

export const SWITCH_USER_ROLE_URL = `${BASE_URL_V6}/user/role/switch`;

export const RESOURCES_URL = `${BASE_URL_V6}/resource`;

export const PARTNER_ADMINS_URL = `${BASE_URL_V6}/partner/admin`;
export const PARTNER_USERS_URL = `${BASE_URL_V6}/partner/user`;

export const PARTNER_CITIZEN_SCIENTIST_URL = `${BASE_URL_V6}/partner/citizen-scientist`;

export const PARTNER_CHILD_URL = `${BASE_URL_V6}/partner/child`;

export const PARTNER_LICENSE_URL = `${BASE_URL_V6}/partner/license`;

export const EMAIL_URL = `${BASE_URL_V6}/email`;

export const MONITOR_URL = `${BASE_URL_V6}/admin/data-by-date`;

export const CHANGE_ROLE_URL = `${BASE_URL_V6}/partner/role/member`;

export const USER_PERMISSION_URL = `${BASE_URL_V6}/user/permissions`;

export const SEGMENT_IMAGES_URL = `${BASE_URL_V6}/image`;

export const SEGMENT_LITTERS_URL = (segmentId) =>
    `${BASE_PARTNER_URL_V6}/segment/${segmentId}/litters`;

export const RESEARCH_PROJECTS_URL = `${BASE_URL_V6}/research/project`;
export const RESEARCH_GET_PLACES_URL = `${BASE_URL_V6}/research/list/place`;
export const RESEARCH_ASSIGN_PLACES_URL = `${BASE_URL_V6}/research/assign/place`;
export const RESEARCH_PLACE_DETAIL_URL = `${BASE_URL_V6}/research/dashboard-place`;
export const RESEARCH_EDIT_PLACE_URL = `${BASE_URL_V6}/research/place`;
export const RESEARCH_UNASSIGN_PLACE_URL = `${BASE_URL_V6}/research/unassign/place`;
export const CREATE_LOCAL_CHALLENGE_URL = `${BASE_URL_V6}/challenge/local`;
export const CREATE_GLOBAL_CHALLENGE_URL = `${BASE_URL_V6}/challenge/global`;
export const CREATE_FEATURED_CHALLENGE_URL = `${BASE_URL_V6}/challenge/connected`;
export const GET_FEATURED_CHALLENGES_URL = `${BASE_URL_V6}/challenge`;
export const SEARCH_CHALLENGES_URL = `${BASE_URL_V6}/challenge/search`;
export const PARTNER_INVITE_URL = `${BASE_URL_V6}/partner/invite`;
export const RESEND_PARTNER_INVITE_URL = `${BASE_URL_V6}/partner/invite-resend`;
export const PARTNER_GET_BY_SIGNATURE = (signature) =>
    `${BASE_PARTNER_URL_V6}/invite/${signature}`;

export const USER_IMAGES_URL = `${BASE_URL_V6}/user/image`;

export const GET_ALL_TAXONOMY_URL = `${BASE_URL_V6}/tags/taxonomy`;

export const UPDATE_TAGS_BY_IMAGE_ID = (imageId) =>
    `${BASE_URL_V6}/tags/image/${imageId}`;

export const GET_PROJECT_LOCATIONS = (projectId) =>
    `${BASE_URL_V6}/research/project/${projectId}/task`;

export const GET_PROJECT_ZONES = (projectId) =>
    `${BASE_URL_V6}/research/project/${projectId}/zone`;

export const GET_LITTERS_FOR_MANY_SEGMENTS = `${BASE_URL_V6}/partner/segment/litters`;

export const UPDATE_RESEARCH_SEGMENT_BY_ID = (segmentId) =>
    `${BASE_URL_V6}/research/segment/${segmentId}/status`;

export const UPDATE_RESEARCH_TASK_BY_ID = (taskId) =>
    `${BASE_URL_V6}/research/task/${taskId}/status`;

export const RESEARCH_PROJECT_BY_ID = (projectId) =>
    `${BASE_URL_V6}/research/project/${projectId}`;

export const RESEARCH_LOCATIONS = `${BASE_URL_V6}/research/location`;

export const RESEARCH_ANALYZE_IMAGE_BY_ID = (imageId) =>
    `${BASE_URL_V6}/admin/images/${imageId}`;
